const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const fetchCredential = async (badgeId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/certificates/${badgeId}`);

    if (!response.ok) {
      return {
        status: false,
        message: "Credential not found",
        records: null,
      };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching credential:", error);
    return {
      status: false,
      message: "Error fetching credential",
      records: null,
    };
  }
};
